import AppScreen from 'components/AppScreen'
import NotificationProvider from 'context/NotificationProvider'
import { ModalProvider } from 'react-modal-hook'

export default function PublicContainer({ children }) {
  return (
    <NotificationProvider>
      <ModalProvider>
        <AppScreen>{children}</AppScreen>
      </ModalProvider>
    </NotificationProvider>
  )
}
